import React, { InputHTMLAttributes } from 'react';

import styled from 'styled-components';
import { IoCheckmarkSharp } from 'react-icons/io5';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.label<{ $fontSize?: number }>`
  margin-left: 10px;
  font-size: ${(props) => (props.$fontSize ? `${props.$fontSize}px` : 'inherit')};
`;

const SCheckbox = styled.label<{ $size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid ${(props) => props.theme.ui.input.borderColor};
  border-radius: 4px;
  width: ${(props) => `${props.$size}px`};
  height: ${(props) => `${props.$size}px`};
  min-width: ${(props) => `${props.$size}px`};
  min-height: ${(props) => `${props.$size}px`};
  cursor: pointer;
  color: ${(props) => props.theme.global.bgColor};

  font-size: 20px;
`;

const Input = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0;
  padding: 0;

  &:checked + ${SCheckbox} {
    background-color: ${(props) => props.theme.global.mainColor};
    border-color: ${(props) => props.theme.global.mainColor};
    color: ${(props) => props.theme.global.whiteTextColor};
  }
`;

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label?: string;
  size?: number;
  fontSize?: number;
}

const Checkbox = React.forwardRef(
  ({ id, label, size = 22, fontSize, ...rest }: CheckboxProps, ref: React.ForwardedRef<HTMLInputElement>) => {
    return (
      <Container>
        <Input ref={ref} id={id} type="checkbox" {...rest} />
        <SCheckbox htmlFor={id} $size={size}>
          <IoCheckmarkSharp />
        </SCheckbox>
        {label && (
          <Label htmlFor={id} $fontSize={fontSize}>
            {label}
          </Label>
        )}
      </Container>
    );
  }
);

export default Checkbox;
